import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';
import ReactGA from 'react-ga';

export class ContactUs extends Component {
    static displayName = ContactUs.name;
    initializeReactGA() {
        ReactGA.initialize('UA-147472286-2');
        ReactGA.pageview('/contactus');
    };

    constructor(props) {
        super(props);
        this.initializeReactGA();
    };

    static renderContactUs() {
        var content =
            <div>
                <div className="row" key={1}>
                    <div className="col-sm">
                        <div className="card mb-3">
                            <div className="card-body">
                                <h5 className="card-title">Quienes somos ?</h5>
                                <p className="card-text">
                                    Ofrecemos una tarifas muy ajustadas, ideales para peque&ntilde;as empresas y comerciantes en general, que se adaptan a todos los bolsillos. 
                                </p>
                                <p className="card-text">
                                    Adem&aacute;s, gracias a nuestro sistema de entrega personalizada podr&aacute; ahorrarse una gran cantidad de dinero que invertir&iacute;a en transporte.
                                    </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" key={2}>
                    <div className="col-sm">
                        <div className="card mb-3">
                            <div className="card-body">
                                <h5 className="card-title">Nuestros clientes</h5>
                                <p className="card-text">
                                    Sabemos lo que desean nuestros clientes, por ello actualizamos nuestros stock de productos cada mes, puedes revisarlo a detalle aqu&iacute; en nuestra web
                                </p>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" key={3}>
                    <div className="col-sm">
                        <div className="card mb-3">
                            <div className="card-body">
                                <h5 className="card-title">Cont&aacute;ctanos</h5>
                                <p className="card-text">
                                    Qu&eacute; podemos hacer por usted?
                                </p>
                                <p className="card-text">
                                    Si&eacute;ntase libre de contactarnos, usted es lo m&aacute;s importante.
                                </p>

                                <ul>
                                    <li>


                                        Direcciones. <span>Dar click en ella para ver el mapa</span> 
                                            <ul>

                                            <li>
                                                
                                                Ventas:<a href="https://www.google.com/maps/place/1%C2%B014'24.4%22S+78%C2%B037'29.8%22W/@-1.2401077,-78.6271183,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d-1.2401077!4d-78.6249296">
                                                        Ecuador-Tungurahua-Ambato-Centro</a>

                                            </li>
                                            <li>
                                                Bodega:<a href="https://www.google.com/maps/place/1%C2%B016'25.9%22S+78%C2%B036'18.2%22W/@-1.2738604,-78.6072532,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d-1.2738604!4d-78.6050645">
                                                        Ecuador-Tungurahua-Amabto-Sur</a>
                                                
                                        </li>
                                            </ul>
                                    </li>
                                    <li>
                                        Tel&eacute;fonos
                                            <ul>

                                            <li>
                                                Phone #1: 03-2824435
                                                </li>

                                            <li>
                                                Phone #2: 0987394954
                                                </li>
                                        </ul>

                                    </li>

                                    <li>
                                        S&iacute;guenos en:
                                        <div>
                                            <SocialIcon url="https://www.facebook.com" />
                                            <SocialIcon url="https://www.instagram.com" />
                                            <SocialIcon url="https://api.whatsapp.com/send?phone=593987394954" />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        return content;
    };

    render() {


        return (
            <div>
                <h1>Distribuidora de productos de aseo</h1>

                <div className="container">
                    {ContactUs.renderContactUs()}
                </div>
            </div>




        );
    }
}
